import { render, staticRenderFns } from "./BCXMarkdown.vue?vue&type=template&id=6067e323&scoped=true"
import script from "./BCXMarkdown.vue?vue&type=script&lang=ts"
export * from "./BCXMarkdown.vue?vue&type=script&lang=ts"
import style0 from "./BCXMarkdown.vue?vue&type=style&index=0&id=6067e323&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6067e323",
  null
  
)

export default component.exports